import { styled } from '@mui/system'

export const TabContent = styled('div')``
